<template>
  <div>
    <v-card outlined rounded="xl">
      <v-data-table
        :headers="headers"
        :items="data"
        :items-per-page="-1"
        hide-default-footer
        class="tabel-uraian"
      >
        <!-- Header tabel -->
        <template v-slot:top>
          <div class="d-flex flex-wrap align-center pa-4">
            <div class="d-flex align-center">
              <v-avatar color="primary" rounded size="44">
                <v-icon color="white">mdi-clipboard-list-outline</v-icon>
              </v-avatar>

              <div class="ml-3">
                <div class="text-h6 font-weight-bold">
                  Bahan Kerja
                </div>
                <div class="text-caption grey--text">
                  Daftar rincian bahan kerja penunjang jabatan
                </div>
              </div>
            </div>

            <v-spacer></v-spacer>

            <v-btn
              color="primary"
              depressed
              rounded
              class="mt-2 mt-sm-0"
              @click="add()"
            >
              <v-icon left small>mdi-plus</v-icon>
              Tambah Data
            </v-btn>
          </div>

          <v-divider></v-divider>
        </template>

        <!-- Nomor -->
        <template v-slot:[`item.nomor`]="{ item }">
          <div class="text-center font-weight-medium grey--text text--darken-2">
            {{
              data.map(function (x) {
                return x.id;
              }).indexOf(item.id) + 1
            }}
          </div>
        </template>


        <template v-slot:[`item.ket`]="{ item }">
          <div class="py-3" style="min-width: 250px; max-width: 500px;">
            <div class="font-weight-medium text-body-2">
              {{ item.ket || "-" }}
            </div>
          </div>
        </template>

        <template v-slot:[`item.penggunaan`]="{ item }">
          <div class="py-3" style="min-width: 250px; max-width: 500px;">
            <div class="font-weight-medium text-body-2">
              {{ item.penggunaan || "-" }}
            </div>
          </div>
        </template>

        <!-- Action -->
        <template v-slot:[`item.action`]="{ item }">
          <div class="d-flex align-center justify-center">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  icon
                  small
                  v-bind="attrs"
                  v-on="on"
                  @click="edit(item)"
                >
                  <v-icon small>mdi-pencil-outline</v-icon>
                </v-btn>
              </template>
              <span>Edit</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="error"
                  icon
                  small
                  v-bind="attrs"
                  v-on="on"
                  @click="hapus(item)"
                >
                  <v-icon small>mdi-trash-can-outline</v-icon>
                </v-btn>
              </template>
              <span>Hapus</span>
            </v-tooltip>
          </div>
        </template>

        <!-- Data kosong -->
        <template v-slot:no-data>
          <div class="text-center py-10">
            <v-icon size="56" color="grey lighten-1">
              mdi-clipboard-text-outline
            </v-icon>

            <div class="text-subtitle-1 font-weight-medium mt-3">
              Belum ada data
            </div>

            <div class="text-body-2 grey--text mb-4">
              Tambahkan data untuk menampilkan uraian tanggung jawab.
            </div>

            <v-btn
              color="primary"
              outlined
              rounded
              @click="add()"
            >
              <v-icon left small>mdi-plus</v-icon>
              Tambah Data
            </v-btn>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <CMadd />
    <CMedit />
    <CMhapus />
  </div>
</template>

<script>
import cookie from "@/helper/cookie.js";

import "@/assets/styles/pages/anjab/infojabatan/baker/view.css";

import CMadd from "@/components/anjab/infojabatan/bahankerja/add";
import CMedit from "@/components/anjab/infojabatan/bahankerja/edit";
import CMhapus from "@/components/anjab/infojabatan/bahankerja/hapus";

import SData from "@/store/anjab/infojabatan/baker";

export default {
  components: {
    CMadd,
    CMedit,
    CMhapus,
  },

  data: () => ({
    session: "",
    token: "",
    loading: false,

    headers: [
      {
        text: "No.",
        value: "nomor",
        width: "60px",
        align: "center",
        sortable: false,
      },
      {
        text: "Nama Gahan Kerja",
        align: "start",
        value: "nama",
        width: "300px",
      },
      {
        text: "Penggunaan",
        align: "start",
        value: "penggunaan",
        width: "300px",
      },
      {
        text: "Aksi",
        value: "action",
        width: "100px",
        align: "center",
        sortable: false,
      },
    ],

    data: [],
  }),

  computed: {
    refresh: {
      get() {
        return SData.state.refresh;
      },
    },

    alert_text: {
      get() {
        return SData.state.alertM;
      },
    },

    alert_b: {
      get() {
        return SData.state.alertB;
      },
    },

    alert_g: {
      get() {
        return SData.state.alertG;
      },
    },
  },

  watch: {
    refresh() {
      if (this.alert_b) {
        this.$swal({
          title: "Sukses!",
          text: this.alert_text,
          icon: "success",
        });
      } else if (this.alert_g) {
        this.$swal({
          title: "Gagal!",
          text: this.alert_text,
          icon: "error",
        });
      }

      this.get_data();
    },
  },

  async mounted() {
    this.session = await JSON.parse(cookie.dec(cookie.get("myCookie")));
    this.token = await cookie.get("token");
    this.get_data();
  },

  methods: {
    get_data() {
      this.loading = true;

      const url = `${process.env.VUE_APP_API}/bakerjab/getjab/${this.$route.params.id}`;

      this.axios
        .get(url, {
          headers: {
            Authorization: "Bearer " + this.token,
          },
        })
        .then((res) => {
          this.loading = false;
          SData.commit("refresh", false);
          this.data = res.data.mapData;
        })
        .catch((error) => {
          console.log(error.response.status);
          console.log("Error", error.message);
        });
    },

    add(item) {
      SData.commit("open_add", {
        value: true,
        item: item,
      });
    },

    edit(item) {
      SData.commit("open_edit", {
        value: true,
        item: item,
      });
    },

    hapus(item) {
      SData.commit("open_delete", {
        value: true,
        item: item,
      });
    },
  },
};
</script>